<script setup lang="ts">

import type { IMarketplaceViewModel } from '@app/MyMarketplace/Types/IMarketplaceViewModel';

const model = defineModel<IMarketplaceViewModel>( { required: true } );

</script>

<template>
    <div class="flex flex-col gap-2 3xl:gap-3 px-4 3xl:px-6"
         @click="() => model.selectCategory( 'nearest', null )">
        <h1 class="flex items-center justify-between tracking-wider text-base 3xl:text-xl">
            Offers near me
        </h1>
        <h2 class="-mt-2 tracking-wider text-sm 3xl:text-lg opacity-40">
            Support local businesses near you 
        </h2>
        <div class="rounded-[8px] overflow-hidden cursor-pointer">
            <img src="@/assets/images/marketplace/offers-near-me.png" class="w-full" />
        </div>
    </div>
</template>